import appLogo from "../../app_icon.png";
import googlePlayIcon from "../../google-play.png";
import React from "react";

export const HomePage = () =>
{
    return (
        <div className="App">
            <header className="App-header">
                {/* App Logo */}
                <img src={appLogo} className="App-logo" alt="App Logo" />

                {/* App Description */}
                <h1 className="App-description-title">
                    Welcome to RL Training Hub!
                </h1>

                <p className="App-description">
                    This app helps you find the Training packs you need from over 2000+ different training packs created by the Rocket League community
                </p>

                {/*<p className="App-description">*/}
                {/*    Whether you're a beginner or an expert, our app provides the tools you need to succeed!*/}
                {/*</p>*/}

                {/* Google Play Store Link */}
                <a
                    href="https://play.google.com/store/apps/details?id=com.popbox.rltrainingpacks" // Replace with your app's actual Google Play Store URL
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img src={googlePlayIcon} className="Playstore-icon" alt="App Logo" />
                </a>
            </header>
        </div>
    );
}